import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  courseWithTopicLessons: [],
  trending: [],
  popular: [],
  featured: [],
  newCourses: [],
  feedbackSubmission: null,
  allCourses: [],
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
